import { useEffect, useState } from "react";
import Loader from "../../components/Loader/Loader";
import Page from "../../components/Page";
import MySubscriptionSection from "../../components/Orders/MySubscriptionSection";

const MySubscriptionPage = () => {

    const [isLoading, setIsLoading] = useState(true);

    return (
        <>
            <Loader start={isLoading} />
            <Page>
                <MySubscriptionSection 
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                />
            </Page>
        </>
    )
}

export default MySubscriptionPage;